import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2bc01f32"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "policy-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_ContentAdaptLayout = _resolveComponent("ContentAdaptLayout")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    "append-to-body": "",
    "custom-class": "process-list-wrap",
    title: "被控制进程",
    "model-value": _ctx.modelValue,
    "show-close": "",
    size: 700,
    onClose: _ctx.handleClose
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ContentAdaptLayout, { class: "main-content important" }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, "策略名称：" + _toDisplayString(_ctx.policyName), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_table, {
            height: "100%",
            data: _ctx.processList,
            "empty-text": _ctx.$t('common.noData')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "name",
                label: "进程名",
                formatter: _ctx.formatTableEmpty
              }, null, 8, ["formatter"]),
              _createVNode(_component_el_table_column, {
                prop: "path",
                label: "进程路径",
                formatter: _ctx.formatTableEmpty
              }, null, 8, ["formatter"]),
              _createVNode(_component_el_table_column, {
                prop: "md5",
                label: "进程MD5",
                formatter: _ctx.formatTableEmpty
              }, null, 8, ["formatter"]),
              _createVNode(_component_el_table_column, {
                prop: "signature",
                label: "数字签名",
                formatter: _ctx.formatTableEmpty
              }, null, 8, ["formatter"])
            ]),
            _: 1
          }, 8, ["data", "empty-text"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value", "onClose"]))
}